import React, { useMemo } from 'react';

import useConfigurations from '@hooks/Configurations/UseConfigurations';

import GroupedCurrencyTotalsBox from '@components/Gui/GroupedCurrencyTotalsBox';

import { groupProjectGroupedStatementsTotalsByCurrency } from './projectGroupedStatementsTotals';

const ProjectGroupedStatementsGrandTotal = ({ contacts }) => {
    const configurations = useConfigurations();

    const totals = useMemo(
        () => groupProjectGroupedStatementsTotalsByCurrency(contacts, configurations.defaultCurrency),
        [contacts, configurations.defaultCurrency]
    );

    if (totals.length === 0) {
        return null;
    }

    return <GroupedCurrencyTotalsBox totals={totals} />;
};

export default ProjectGroupedStatementsGrandTotal;
